import React, { useEffect, useCallback } from "react";
import { useNavigate, useLocation } from 'react-router-dom';
import "./index.scss";
import AppTool from '@utils/app-tool';

const HeaderComponent = () => {
	const navigate = useNavigate();

	const location = useLocation();  // Hook from React Router to access the location object

	const handleScroll = useCallback((className) => {
		console.log('handleScroll', className);
		// 检查是否在首页
		if (location.pathname === '/') {
			const element = document.querySelector(className);
			if (element) {
				element.scrollIntoView({ behavior: 'smooth', block: 'start' });
			}
		}
		else {
			/*if (className == '.cMainNewsPage') {
				navigate('/news')
			}
			else if (className == '.cCharacter') {
				navigate('/avatar')
			}
			else {
				navigate('/')
			}*/
			navigate('/?scroll=' + className)
		}
	}, [navigate, location.pathname]);

	useEffect(() => { // Similar to componentDidMount and componentDidUpdate:
		const searchParams = new URLSearchParams(location.search);
		const scroll = searchParams.get('scroll');
		if (scroll) {
			setTimeout(() => {
				handleScroll(scroll);
			}, 1000);
		}
	}, [location.search, handleScroll]);


	return (
		<div className="cHeaderComponent" >
			<div className="cPhoneMenuDialog cDialogAttr" onClick={() => { }}>
				<div className="cMask" onClick={() => { AppTool.closeDialog('.cPhoneMenuDialog') }}></div>
				<div className="cDialog" >
					<img className="cMenuCloss" src={window.assetUrl(`/images/home/phone-menu-closs.png`)} onClick={() => { AppTool.closeDialog('.cPhoneMenuDialog') }} alt='' />
					<img className="cMenuOff" src={window.assetUrl(`/images/home/phone-menu-off.png`)} onClick={() => { AppTool.closeDialog('.cPhoneMenuDialog') }} alt='' />
					<div className="cItem">
						<img src={window.assetUrl('/images/home/top-bar01-index.png')} onClick={() => { handleScroll('.cMainBox'); AppTool.closeDialog('.cPhoneMenuDialog') }} alt='' />
					</div>
					<div className="cItem">
						<img src={window.assetUrl('/images/home/top-bar02-news.png')} onClick={() => { handleScroll('.cMainNewsPage'); AppTool.closeDialog('.cPhoneMenuDialog') }} alt='' />
					</div>
					<div className="cItem">
						<img src={window.assetUrl('/images/home/top-bar03-world.png')} onClick={() => { handleScroll('.cWorld'); AppTool.closeDialog('.cPhoneMenuDialog') }} alt='' />
					</div>
					<div className="cItem">
						<img src={window.assetUrl('/images/home/top-bar04-character.png')} onClick={() => { handleScroll('.cCharacter'); AppTool.closeDialog('.cPhoneMenuDialog') }} alt='' />
					</div>
					<div className="cItem">
						<img src={window.assetUrl('/images/home/top-bar05-system.png')} onClick={() => { handleScroll('.cSystemPage'); AppTool.closeDialog('.cPhoneMenuDialog') }} alt='' />
					</div>
					<div className="cItem">
						<img src={window.assetUrl('/images/home/top-bar06-topup.png')} onClick={() => { window.open('https://pay.mahoyakuzh.com/#') }} alt='' />
					</div>
					<div className="cItem">
						<img src={window.assetUrl('/images/home/top-bar07-serial-number-exchange.png')} onClick={() => { navigate('/voucher'); AppTool.closeDialog('.cPhoneMenuDialog') }} alt='' />
					</div>
				</div>
			</div>
			<div className="cBg" />
			<div className="cButton cPc">
				<img src={window.assetUrl('/images/home/top-bar01-index.png')} onClick={() => { handleScroll('.cMainBox') }} alt='' />
				<img src={window.assetUrl('/images/home/top-bar02-news.png')} onClick={() => { handleScroll('.cMainNewsPage') }} alt='' />
				<img src={window.assetUrl('/images/home/top-bar03-world.png')} onClick={() => { handleScroll('.cWorld') }} alt='' />
				<img src={window.assetUrl('/images/home/top-bar04-character.png')} onClick={() => { handleScroll('.cCharacter') }} alt='' />
				<img src={window.assetUrl('/images/home/top-bar05-system.png')} onClick={() => { handleScroll('.cSystemPage') }} alt='' />
				<img src={window.assetUrl('/images/home/top-bar06-topup.png')} onClick={() => { window.open('https://pay.mahoyakuzh.com/#') }} alt='' />
				<img src={window.assetUrl('/images/home/top-bar07-serial-number-exchange.png')} onClick={() => navigate('/voucher')} alt='' />
			</div>
			<div className="cButton cMobile">
				<img src={window.assetUrl('/images/home/phone-menu.png')} alt="" onClick={() => { AppTool.openDialog('.cPhoneMenuDialog') }} />
			</div>
		</div>
	);
}

export default HeaderComponent;